import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_URL } from "../../app.config";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { editChallengeApiCall } from "../../Store/slices/challengeSlice";
import { uploadImageOnAWS } from "../../utils/aws.service";
import {
  convertToBase64,
  TOAST_ERROR,
  TEXT_WITH_NOT_START_SPACE_VALIDATION,
  NUMBER_VALIDATION,
} from "../../utils/common.service";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function EditChallenge() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const challengeData = location?.state?.challengeData;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
  } = useForm();

  const [challengeType, setChallengeType] = useState("daily");
  const [tournamentImageState, setTournamentImageState] = useState(
    PUBLIC_URL + "/assets/images/default_logo.jpg"
  );
  const [letterImageState, setLetterImageState] = useState(
    PUBLIC_URL + "/assets/images/default_letter.jpg"
  );
  // const [backgroundImageState, setBackgroundImageState] = useState(
  //   PUBLIC_URL + "/assets/images/default_background.jpg"
  // );
  const [isFree, setIsFree] = useState(challengeData?.is_free);
  const [font, setFont] = useState(challengeData?.font || "Ruqa");
  useEffect(() => {
    if (challengeData) {
      setChallengeType(challengeData?.challenge_type || "daily");
      setLetterImageState(
        challengeData?.latter_image ||
          PUBLIC_URL + "/assets/images/default_letter.jpg"
      );
      setIsFree(challengeData?.is_free || false);
      // setBackgroundImageState(
      //   challengeData?.background_image ||
      //     PUBLIC_URL + "/assets/images/default_background.jpg"
      // );
      reset({
        challenge_title: challengeData?.challenge_title || "",
        ar_challenge_title: challengeData?.ar_challenge_title || "",
        latter_image: challengeData?.letter_name,
        image_title: challengeData?.image_title || "",
        ar_image_title: challengeData?.ar_image_title || "",
        points: challengeData?.points || "",
        skip_point: challengeData?.skip_point || "",
        challenge_date: challengeData?.challenge_date || "",
        description: challengeData?.description || "",
        ar_description: challengeData?.ar_description || "",
        challenge_type: challengeData?.challenge_type || "daily",
        total_used_line: challengeData?.total_used_line || "",
        start_date: challengeData?.start_date || "",
        end_date: challengeData?.end_date || "",
        font: challengeData?.font || "Ruqa",
      });
    }
  }, [challengeData, reset]);

  const handleImageChange = async (image, field) => {
    if (image) {
      let imageSize = image.size / 1024;
      if (imageSize > 3072) {
        TOAST_ERROR("Please select an image smaller than 3MB");
      } else {
        setValue(field, image);
        const bufferImage = await convertToBase64(image);
        switch (field) {
          case "tournamentImage":
            setTournamentImageState(bufferImage);
            break;
          case "letterImage":
            setLetterImageState(bufferImage);
            break;
          // case "backgroundImage":
          //   setBackgroundImageState(bufferImage);
          //   break;
          default:
            break;
        }
        clearErrors(field);
      }
    }
  };

  const onSubmit = async (submitData) => {
    try {
      dispatch(setLoader(true));
      let requestBody = {
        id: challengeData?.id,
        latter_image: submitData?.letterImage || challengeData?.letter_name,
        challenge_title: submitData.challenge_title,
        ar_image_title: submitData.ar_image_title,
        ar_challenge_title: submitData.ar_challenge_title,
        image_title: submitData.image_title,
        points: submitData.points,
        skip_point: submitData.skip_point,
        start_date: submitData?.start_date,
        end_date: submitData?.end_date,
        description: submitData.description,
        ar_description: submitData.ar_description,
        challenge_type: challengeType,
        total_used_line: submitData.total_used_line,
        is_free: isFree,
        font: submitData.font || font,
      };

      const imageFieldMapping = {
        letterImage: "latter_image",
      };

      let image = submitData.letterImage;
      if (image instanceof Blob) {
        image = await uploadImageOnAWS(image, "challenge");
        requestBody[imageFieldMapping.letterImage] = image;
      }

      await dispatch(editChallengeApiCall(requestBody));
      navigate(`/manage_challenge`);
      reset();
    } catch (err) {
      TOAST_ERROR(err.message);
    } finally {
      dispatch(setLoader(false));
    }
  };

  return (
    <div className="content">
      <div className="container-fluid">
        <SubNavbar
          title={`Edit Challenge`}
          header={`challenge`}
          subHeader={`Edit Challenge`}
        />
        <div className="card rounded-3">
          <div className="card-body">
            <div className="d-flex justify-content-lg-start">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => navigate(-1)}
              >
                <IoMdArrowRoundBack fontSize={"20px"} />
              </button>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-3 d-flex justify-content-center">
                {/* Letter Image */}
                <div className="col-md-6">
                  <Controller
                    name="letterImage"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <div className="d-flex flex-column align-items-center">
                        <img
                          src={letterImageState}
                          alt="letter image"
                          className="img-fluid img-thumbnail"
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "10%",
                          }}
                        />
                        <label htmlFor="letterImage">
                          <div className="upload-document mt-2">
                            <div className="btn btn-outline-info m-1">
                              Choose Letter Image
                            </div>
                          </div>
                        </label>
                      </div>
                    )}
                  />
                  <input
                    type="file"
                    id="letterImage"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      handleImageChange(e.target.files[0], "letterImage")
                    }
                    accept="image/svg+xml"
                  />
                </div>
              </div>
              {/* title fild */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="challenge_title" className="form-label">
                    Challenge Title
                  </label>
                  <input
                    type="text"
                    id="challenge_title"
                    className="form-control"
                    {...register(
                      "challenge_title",
                      TEXT_WITH_NOT_START_SPACE_VALIDATION("challenge_title")
                    )}
                    aria-invalid={errors.email ? "true" : "false"}
                  />
                  <div className="errorc">
                    {errors.challenge_title?.message}
                  </div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="image_title" className="form-label">
                    Image Title
                  </label>
                  <input
                    type="text"
                    id="image_title"
                    className="form-control"
                    {...register(
                      "image_title",
                      TEXT_WITH_NOT_START_SPACE_VALIDATION("image_title")
                    )}
                    aria-invalid={errors.email ? "true" : "false"}
                  />
                  <div className="errorc">{errors.image_title?.message}</div>
                </div>
              </div>

              {/* arebic title fild */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="ar_challenge_title" className="form-label">
                    Challenge Title(Arabic)
                  </label>
                  <input
                    type="text"
                    id="ar_challenge_title"
                    className="form-control"
                    {...register(
                      "ar_challenge_title",
                      TEXT_WITH_NOT_START_SPACE_VALIDATION("ar_challenge_title")
                    )}
                    aria-invalid={errors.ar_challenge_title ? "true" : "false"}
                  />
                  <div className="errorc">
                    {errors.ar_challenge_title?.message}
                  </div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="ar_image_title" className="form-label">
                    Image Title(Arabic)
                  </label>
                  <input
                    type="text"
                    id="ar_image_title"
                    className="form-control"
                    {...register(
                      "ar_image_title",
                      TEXT_WITH_NOT_START_SPACE_VALIDATION("ar_image_title")
                    )}
                    aria-invalid={errors.ar_image_title ? "true" : "false"}
                  />
                  <div className="errorc">{errors.ar_image_title?.message}</div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <label htmlFor="points" className="form-label">
                    Points
                  </label>
                  <input
                    type="text"
                    id="points"
                    className="form-control"
                    {...register("points", NUMBER_VALIDATION("points"))}
                    aria-invalid={errors.email ? "true" : "false"}
                  />
                  <div className="errorc">{errors.points?.message}</div>
                </div>

                <div className="col-md-4">
                  <label htmlFor="skip_point" className="form-label">
                    Skip Points
                  </label>
                  <input
                    type="text"
                    id="skip_point"
                    className="form-control"
                    {...register(
                      "skip_point",
                      NUMBER_VALIDATION("skip points")
                    )}
                    aria-invalid={errors.email ? "true" : "false"}
                  />
                  <div className="errorc">{errors.skip_point?.message}</div>
                </div>

                <div className="col-md-4">
                  <label htmlFor="total_used_line" className="form-label">
                    Total Line
                  </label>
                  <input
                    type="text"
                    id="total_used_line"
                    className="form-control"
                    {...register(
                      "total_used_line",
                      NUMBER_VALIDATION("total line")
                    )}
                    aria-invalid={errors.email ? "true" : "false"}
                  />
                  <div className="errorc">
                    {errors.total_used_line?.message}
                  </div>
                </div>
              </div>

              {/* Challenge Type Dropdown */}
              <div className="row mb-3">
                <div className="col-md-4">
                  <label htmlFor="challenge_type" className="form-label">
                    Challenge Type
                  </label>
                  <select
                    id="challenge_type"
                    className="form-select"
                    {...register("challenge_type")}
                    onChange={(e) => setChallengeType(e.target.value)}
                  >
                    <option value="daily">Daily</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </div>

                {/* Font Dropdown */}
                <div className="col-md-4">
                  <label htmlFor="font" className="form-label">
                    Font
                  </label>
                  <select
                    id="font"
                    className="form-select"
                    {...register("font", { required: "font is required" })}
                    value={font}
                    onChange={(e) => {
                      setFont(e.target.value);
                      setValue("font", e.target.value);
                    }}
                  >
                    <option key="Ruqa" value="Ruqa">Ruqa</option>
                    <option key="Naskh" value="Naskh">Naskh</option>
                  </select>
                  <div className="errorc">{errors.font?.message}</div>
                </div>
                {/*start date*/}
                <div className="col-md-4">
                  <label htmlFor="start_date" className="form-label">
                    Start Date
                  </label>
                  <input
                    type="datetime-local"
                    id="start_date"
                    className="form-control"
                    {...register("start_date", {
                      required: "Start date is required",
                    })}
                  />
                  <div className="errorc">{errors.start_date?.message}</div>
                </div>
                {/*end date*/}
                <div className="col-md-4">
                  <label htmlFor="end_date" className="form-label">
                    End Date
                  </label>
                  <input
                    type="datetime-local"
                    id="end_date"
                    className="form-control"
                    {...register("end_date", {
                      required: "End date is required",
                    })}
                  />
                  <div className="errorc">{errors.end_date?.message}</div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">
                    Description
                  </label>
                  <textarea
                    id="description"
                    className="form-control"
                    {...register("description")}
                  />
                  <div className="errorc">{errors.description?.message}</div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <label htmlFor="ar_description" className="form-label">
                    Description(Arabic)
                  </label>
                  <textarea
                    id="ar_description"
                    className="form-control"
                    {...register("ar_description")}
                  />
                  <div className="errorc">{errors.ar_description?.message}</div>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Is Free:</label>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="isFree"
                    checked={isFree === "true"}
                    onChange={(e) =>
                      setIsFree(e.target.checked ? "true" : "false")
                    }
                  />
                  <label className="form-check-label" htmlFor="isFree">
                    {isFree === "true" ? "Active" : "Inactive"}
                  </label>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-3">
                <button type="submit" className="btn btn-primary">
                  Update Challenge
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
